import React from 'react';

interface Props {
  homeinspectionNegotiationDays?: number;
}

const LeasebasedPaintInspextion = ({
  homeinspectionNegotiationDays,
}: Props) => {
  return (
    <>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Lease-Based Paint Inspection Contingency Clause
      </h2>
      <p>
        This contract is contingent upon the Buyer obtaining, at their own
        expense, a professional Lease-Based Paint inspection of the Property
        within {homeinspectionNegotiationDays} days from the date of contract
        execution. The inspection shall assess the condition and functionality
        of the property's Lease-Based Paint system.
      </p>
      <p>
        Should the inspection reveal any material defects, obstructions, or
        deficiencies in the Lease-Based Paint system, the Buyer shall have the
        right to:
      </p>
      <div className="ml-6 space-y-2">
        <p>
          <strong>a)</strong> <strong>Request Repairs or Remedies:</strong>{' '}
          Notify the Seller, in writing, within the inspection period of{' '}
          {homeinspectionNegotiationDays} days after the execution date,
          detailing the specific repairs or remedies required. The Seller shall
          respond and agree to the requested repairs or provide an alternative
          resolution acceptable to the Buyer within the inspection period.
        </p>
        <p>
          <strong>b)</strong> <strong>Terminate the Contract:</strong> If the
          Seller fails to agree to or complete the requested repairs or if an
          acceptable resolution is not reached within the specified or agreed to
          time frame, the Buyer may, at their sole discretion, terminate this
          contract by providing written notice to the Seller. Upon such
          termination, all deposits made by the Buyer shall be promptly refunded
          in full, and neither party shall have any further obligations under
          this contract.
        </p>
      </div>
      <p>
        Access to the Property for the purpose of conducting the Lease-Based
        Paint inspection shall be provided by the Seller with reasonable notice
        to the Seller's Agent. If the Buyer chooses to conduct additional home
        inspections beyond the Lease-Based Paint inspection, those shall also be
        conducted at the Buyer's expense, with similar access provisions.
      </p>
      <p>
        This contingency shall be deemed satisfied or waived if the Buyer does
        not deliver written notice to the Seller regarding the inspection
        results and any required actions within the specified time frames.
      </p>
    </>
  );
};

export default LeasebasedPaintInspextion;
